export default __webpack_public_path__ + "static/media/ups-icon.720f6f27.svg";